
import DateFormat from '@/services/DateFormat'
import AuthService from '@/services/support/AuthService'
import LogService, { ToString } from '@/services/support/LogService'
import Vue from 'vue'
export default Vue.extend({
  props: {
    session: {
      type: Object,
      required: true
    },
    userCredentials: {
      type: Object
    }
  },
  data () {
    return {
      EVENT_TIME: 750, // milliseconds
      MOBILE_UUID_SIZE: 16,
      attemptToDelete: false as boolean,
      deletingSession: false as boolean,
      responseOnDelete: 0 as number // 0: init, 1: success, 2: error
    }
  },
  mounted () {
    this.initCard()
  },
  computed: {
    isMobile (): boolean {
      return this.session.device.uuid.length <= this.MOBILE_UUID_SIZE
    },
    sessionDeleted (): boolean {
      return this.responseOnDelete === 1
    },
    errorOnDelete (): boolean {
      return this.responseOnDelete === 2
    }
  },
  watch: {
  },
  methods: {
    initCard (): void {
      this.attemptToDelete = false
      this.deletingSession = false
      this.setResponseOndelete(0)
    },
    /**
     * Do a request to delete a session by its ID.
     *
     * @param sessionId id of the session to delete
     */
    closeSession (sessionId: number): void {
      this.deletingSession = true
      AuthService.deleteUserSession(sessionId, this.userCredentials)
        .then(() => {
          this.setResponseOndelete(1)
          setTimeout(() => {
            this.$emit('remove-session', sessionId)
          }, this.EVENT_TIME)
        })
        .catch((error) => {
          LogService.error(`Error en liberación de sesión: ${ToString(error.response ?? error)}`)
          this.setResponseOndelete(2)
        })
        .finally(() => {
          setTimeout(() => {
            this.initCard()
          }, this.EVENT_TIME * 4)
        })
    },
    /**
     * Set the 'value' in the 'attemptToDelete' variable
     * @param value to set
     */
    setAttemptToDelete (value: boolean): void {
      this.attemptToDelete = value
    },
    /**
     * Set the 'state' in the 'responseOnDelete' variable
     *    0: initial state
     *    1: successful state
     *    2: failed state
     * @param state to set
     */
    setResponseOndelete (state: number): void {
      this.responseOnDelete = state
    },
    /**
     * Return a string date in local format
     *
     * @param date ISO string date to work with
     */
    dateFormat (date: string): string {
      const localDate = new DateFormat(new Date(date))
      return localDate.toDateTimeString()
    }
  }
})
